import React from 'react'
import Image from 'next/image'

const Logo = () => {
    return (
        <>
            <Image
                src="/logo.svg"
                className="primary-logo"
                alt="startrum"
                width={171}
                height={24}
            />
            <Image
                src="/logo.svg"
                className="reverse-logo"
                alt="startrum"
                width={171}
                height={24}
            />
        </>
    )
}

export default Logo
